import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

export interface Service {
  id: number;
  name: string;
  description: string;
  price: string;
  duration?: string;
  icon?: string;
  image_url?: string;
  gradient?: string;
  border_color?: string;
  sort_order: number;
  is_active: boolean;
  is_featured?: boolean;
  metadata?: string;
}

export interface ServiceZone {
  id: number;
  name: string;
  description?: string;
  coverage?: string;
  icon?: string;
  sort_order: number;
  is_active: boolean;
}

export interface ContactInfo {
  id: number;
  type: string;
  label: string;
  value: string;
  icon?: string;
  sort_order: number;
  is_active: boolean;
}

export interface SiteContent {
  id: number;
  key: string;
  title: string;
  content: string;
  category: string;
  icon?: string;
  image_url?: string;
  sort_order: number;
  is_active: boolean;
  metadata?: string;
}

export interface CompanyInfo {
  id: number;
  name: string;
  description?: string;
  tagline?: string;
  mission?: string;
  vision?: string;
  values?: string;
  logo_url?: string;
  address?: string;
}

export const getAllServices = async (): Promise<Service[]> => {
  const response = await axios.get(`${API_BASE_URL}/services`);
  return response.data || [];
};

export const getAllServiceZones = async (): Promise<ServiceZone[]> => {
  const response = await axios.get(`${API_BASE_URL}/service-zones`);
  return response.data || [];
};

export const getAllContactInfo = async (): Promise<ContactInfo[]> => {
  const response = await axios.get(`${API_BASE_URL}/contact-info`);
  return response.data || [];
};

export const getContentByCategory = async (category: string): Promise<SiteContent[]> => {
  const response = await axios.get(`${API_BASE_URL}/content/category/${category}`);
  return response.data || [];
};

export const getCompanyInfo = async (): Promise<CompanyInfo | null> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/company-info`);
    return response.data;
  } catch {
    return null;
  }
};

// Helper functions
export const getRegularServices = async (): Promise<Service[]> => {
  const services = await getAllServices();
  return services.filter(s => !s.metadata || !s.metadata.includes('"type":"custom"'));
};

export const getCustomServices = async (): Promise<Service[]> => {
  const services = await getAllServices();
  return services.filter(s => s.metadata && s.metadata.includes('"type":"custom"'));
};
